import React, { useEffect, useState } from 'react';
import fetch from '../Utils/fetch';
import { useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../store/alert';
import { addProducts } from '../../store/products';
import Searchbar from '../Components/searchbar';
import ProductSlider from '../Products/ProductSlider';
import Universalheader from '../Headers/universalheader';
import { Button, CircularProgress, Skeleton } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';



const Allcategories = () => {
	useDocumentTitle('Products & Services');

	const navigate = useNavigate()
	const dispatch = useDispatch();
	const products = useSelector((state) => state.products.data);
	const subProducts = useSelector((state) => state.subProducts.data);
	const categories = useSelector((state) => state.categories.data);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [productGroups, setProductGroups] = useState([]);
	const [productsToView, setProductsToView] = useState([]);
	const [viewGroupPosition, setViewGroupPosition] = useState(0);

	const [showsearchbar, setshowsearchbar] = useState(false);

	useEffect(() => {
		loadData();
		window.scrollTo(0, 0);
	}, []);




	function loadData() {
		setLoading(true);
		dispatch(setAlert({ type: 'warning', message: 'Loading Products and Services...' }));
		fetch
			.get('getProductsAndServices')
			.then((res) => {
				dispatch(setAlert('Done loading products and services'));
				dispatch(addProducts(res.list));
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false);
				setError(err.message);
				dispatch(setAlert({ type: 'error', message: 'Error fetching data. ' + err.message }));
			});
	}


	return (<div className="homebody">
		{showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
		<Universalheader onshowsearchbar={() => setshowsearchbar(true)} />
		{products && !loading &&
			products.length > 0 &&
			products.map((data, index) => (
				<div className="sections" key={data.group_name + index}>
					<section className="sectionheader">
						<div className="sectionheadertitle">{_.startCase(_.lowerCase(data.group_name))}</div>
						<Button color='secondary' variant="text" onClick={() => navigate(`/categoryitems`, { state: { category: data } })} endIcon={<ChevronRight />}>View All</Button>
					</section>
					<ProductSlider products={data.items?.slice(0, 60)} />
				</div>
			))}
		{loading &&
			<div>
				{Array.from({ length: 20 }, (_, index) => {
					return (
						<div>
							<Skeleton variant="rectangular" sx={{ height: 50, width: 450, marginBottom: 2 }} />
							<ProductSlider products={[]} />
						</div>
					)
				})}

			</div>
		}
	</div>)
}

export default Allcategories